module.exports = {
  PoNo: 'Số đơn hàng',
  ItemNo: 'Mã SKU',
  JobNo: 'Mã nghiệp vụ tuyến chính',
  Supplier: 'Nhà cung cấp',
  LoadingPort: 'Cảng đi',
  DestinationPort: 'Cảng đến',
  WarehouseNo: 'Mã nhập kho',
  State: 'Trạng thái',
  OperationRequirement: 'Yêu cầu thao tác',
  RequestedIncomeDate: 'Thời gian yêu cầu nhập kho',
  EstimatedIncomeDate: 'Thời gian dự kiến nhập kho',
  ETD: 'Thời gian dự kiến rời cảng',
  LoadingDate: 'Thời gian hoàn thành đóng hàng',
  RequestedDeliveryDate: 'Thời gian yêu cầu giao hàng',
  EstimatedDeliveryDate: 'Thời gian dự kiến giao hàng',
  POCreationDate: 'Thời gian tạo PO',
  DeliveryDate: 'Thời gian tiếp nhận',
  DateModified: 'Thời gian cập nhật',
  Producer: 'Nhà sản xuất',
  PackageEstimatedIncomeDate: 'Thời gian dự kiến hàng sẵn sàng',
  IncomeDate: 'Thời gian nhập kho thực tế',
  WarehouseInState: 'Trạng thái nhập kho',
  DeliveryAddr: 'Địa chỉ nhận hàng',
  IncomeDelayReason: 'Lý do chậm nhập kho',
  ContainerState: 'Trạng thái container',
  DepartureDelayReason: 'Lý do chậm rời cảng',
  PleaseSelectTheOrderToDelete: 'Vui lòng chọn đơn hàng cần xóa',
  onlyOneOrderCanBeDeletedAtATime: 'Chỉ được xóa một đơn hàng mỗi lần',
  onlyCancelledOrdersCanBeDeleted: 'Chỉ đơn hàng đã hủy mới có thể xóa',
  areYouSureToDeleteThisOrder: 'Bạn có chắc chắn muốn xóa đơn hàng này?',
  deleteOrder: 'Xóa đơn hàng',
  Shipper: 'Bên giao hàng',
  RelatedParty: 'Bên liên quan',
  Consignee: 'Bên nhận hàng',
  EntrustingDate: 'Ngày ủy thác'
}
